import { transEnum } from '@luminovo/commons';
import { Tag } from '@luminovo/design-system';
import { AssemblyIndustry } from '@luminovo/http-client';
import { assemblyIndustryTranslations } from '../../i18n';

export const IndustryTag = ({ industry }: { industry: AssemblyIndustry }): JSX.Element => {
    return <Tag attention={'low'} color="primary" label={transEnum(industry, assemblyIndustryTranslations)} />;
};
